import { RoutineColors } from "@/utilities/routineColors";
import type { Routine } from "instantdb/types";

export const FITNESS_ROUTINES: Partial<Routine>[] = [
  {
    id: "morning-movement-kickstart",
    title: "Morning Movement Kickstart",
    symbol: "🏃",
    description: "Begin your day with energizing exercises",
    dailyRoutine: true,
    selectedDays: [],
    color: RoutineColors[6].value,
    steps: [
      {
        id: "fitness-morning-1",
        title: "Warm-up",
        description: "Gentle stretching and joint mobility for 3-5 minutes",
      },
      {
        id: "fitness-morning-2",
        title: "Bodyweight circuit",
        description: "Complete 2 rounds of squats, push-ups, and jumping jacks (10 each)",
      },
      {
        id: "fitness-morning-3",
        title: "Cool down",
        description: "Deep breathing and gentle stretching for 2-3 minutes",
      },
    ],
  },
  {
    id: "strength-training-session",
    title: "Strength Training Session",
    symbol: "🏋️",
    description: "Build muscle and improve overall strength",
    dailyRoutine: false,
    selectedDays: [
      { day: "monday", datetime: "17:00:00.000Z" },
      { day: "wednesday", datetime: "17:00:00.000Z" },
      { day: "friday", datetime: "17:00:00.000Z" },
    ],
    color: RoutineColors[7].value,
    steps: [
      {
        id: "fitness-strength-1",
        title: "Dynamic warm-up",
        description: "Prepare your body with 5-10 minutes of active movements",
      },
      {
        id: "fitness-strength-2",
        title: "Strength exercises",
        description: "Complete 3 sets of compound movements (squats, rows, presses)",
      },
      {
        id: "fitness-strength-3",
        title: "Recovery stretches",
        description: "Perform static stretches focusing on worked muscle groups",
      },
    ],
  },
  {
    id: "active-recovery-day",
    title: "Active Recovery Day",
    symbol: "🏃",
    description: "Promote circulation and recovery between harder workouts",
    dailyRoutine: false,
    selectedDays: [
      { day: "tuesday", datetime: "17:00:00.000Z" },
      { day: "thursday", datetime: "17:00:00.000Z" },
    ],
    color: RoutineColors[8].value,
    steps: [
      {
        id: "fitness-recovery-1",
        title: "Light cardio",
        description: "15-20 minutes of walking, easy cycling, or swimming",
      },
      {
        id: "fitness-recovery-2",
        title: "Mobility work",
        description: "Focus on hip, shoulder, and spine mobility exercises",
      },
      {
        id: "fitness-recovery-3",
        title: "Gentle stretching",
        description: "Hold each stretch for 30-60 seconds for full-body flexibility",
      },
    ],
  },
];
